export const Logout = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_9119_352)">
        <path
          d="M12.583 6.29999C12.3247 3.29999 10.783 2.07499 7.40801 2.07499H7.29967C3.57467 2.07499 2.08301 3.56666 2.08301 7.29166V12.725C2.08301 16.45 3.57467 17.9417 7.29967 17.9417H7.40801C10.758 17.9417 12.2997 16.7333 12.5747 13.7833"
          stroke="#EF4444"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.50006 10H16.9834"
          stroke="#EF4444"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.1253 7.20833L17.917 10L15.1253 12.7917"
          stroke="#EF4444"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_9119_352">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="matrix(-1 0 0 1 20 0)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
